import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#183EEB',
    },
    secondary: {
      main: '#00024F',
    },
    background: {
      default: '#F8FAFF',
      paper: '#ffffff',
    },
    text: {
      primary: '#010028',
      secondary: '#6c7293',
    },
  },
  typography: {
    fontFamily: "'Rubik', sans-serif",
  },
});

export default theme;
